<template>
  <li class="mb-2">
    <nuxt-link
      v-if="navItem.type === 'nuxt'"
      :to="navItem.data.url"
      :data-testid="testId([navItem.label, 'sidebar-link'])"
      class="block rounded-md p-1 text-mouse no-underline transition-colors hover:bg-black/10"
      active-class="bg-black/10 cursor-default"
    >
      <fa-icon
        v-if="navItem.icon"
        class="mr-2 inline-block size-4 text-rhino"
        :icon="navItem.icon"
      />
      {{ translateLabel(navItem) }}
    </nuxt-link>
    <a
      v-else
      :href="navItem.data.url"
      :data-testid="testId([navItem.label, 'sidebar-link'])"
      class="block rounded-md p-1 text-mouse no-underline transition-colors hover:bg-black/10"
      :class="{ 'bg-black/10 cursor-default': isActive }"
      :target="navItem.type === 'external' ? '_blank' : undefined"
      :rel="navItem.type === 'external' ? 'noopener' : undefined"
    >
      <fa-icon
        v-if="navItem.icon"
        class="mr-2 inline-block size-4 text-rhino"
        :icon="navItem.icon"
      />
      {{ translateLabel(navItem) }}
    </a>
  </li>
</template>

<script setup lang="ts">
import testId from '~/helpers/testid';
import {
  type SideNavigationItem,
  SideNavigationItemTypes,
} from '#variant/components/navigation/types';
import { useLabelTranslation } from '../features/utils';

const props = defineProps<{
  navItem: SideNavigationItem;
}>();

const route = useRoute();
const translateLabel = useLabelTranslation();

const isActive = computed(() => {
  if (props.navItem.type === SideNavigationItemTypes.EXTERNAL) return false;
  return route.path.endsWith(props.navItem.data.url);
});
</script>
